import { useEffect } from 'react';
import { useAuthStore } from '@/stores';
import * as authApi from '@/services/api/auth';

/**
 * Hook that checks authentication status on mount.
 * Updates the auth store with the result.
 * Does not handle navigation - that's the caller's responsibility.
 */
export function useAuthCheck() {
  const { isAuthenticated, user, login, setLoading } = useAuthStore();

  useEffect(() => {
    const checkAuth = async () => {
      // Skip if already authenticated AND we have user data
      if (isAuthenticated && user) {
        setLoading(false);
        return;
      }

      setLoading(true);
      try {
        const { user: fetchedUser, session } = await authApi.getCurrentUser();
        login(fetchedUser, session);
      } catch {
        // Not authenticated - that's fine, setLoading(false) will trigger redirect
        setLoading(false);
      }
    };

    checkAuth();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);
}
